// @copyright Highway9 Networks

import { RootState, store } from ".";
export function observeStoreChange<T>(select: (state: RootState) => T, onChange: (state: T) => void) {
  let currentState: T;

  function handleChange() {
    const nextState = select(store.getState());
    if (nextState !== currentState) {
      currentState = nextState;
      onChange(currentState);
    }
  }

  const unsubscribe = store.subscribe(handleChange);
  handleChange();
  return unsubscribe;
}

/**
 * Calculate the tick interval for the graph
 * @param ticks - The number of ticks to calculate the interval for
 * @returns The tick interval
 */
export function calcTickInterval(ticks = 6) {
  const _store = store.getState() as RootState;
  const { diff } = _store.utility.time;
  return Math.round(diff / ticks);
}
